import { Schema } from "components/Schema";
import type { SchemaAdapterProps } from "./Schema.d";

const SchemaAdapter = ({ blok: { schema } }: SchemaAdapterProps) => <Schema schema={schema} />;

export default SchemaAdapter;
